import type { RouteRecordRaw } from 'vue-router';

const MainLayout = () => import('@/shared/layouts/pages/MainLayout/index.vue');
const WalletDetail = () => import('../pages/WalletDetail/index.vue');
const WalletDocumentCertificate = () => import('../views/WalletDocumentCertificate/index.vue');
const WalletDocumentExtract = () => import('../views/WalletDocumentExtract/index.vue');

export const walletRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: MainLayout,
    children: [
      {
        path: 'wallets/:walletId',
        name: 'wallet-detail',
        meta: {
          hideNavbar: false,
          accessRol: {
            section: 'WALLET',
            actions: ['VIEW'],
          },
        },
        component: WalletDetail,
      },
      {
        path: 'wallets/:walletId/document-extract',
        name: 'wallet-document-extract-view',
        meta: {
          title: 'Descargar Documentos',
          accessRol: {
            section: 'CARD',
            actions: ['DOWNLOAD_STATEMENT'],
          },
        },
        component: WalletDocumentExtract,
      },
      {
        path: 'wallets/:walletId/document-certificate',
        name: 'wallet-document-certificate-view',
        meta: {
          title: 'Descargar Certificado',
          accessRol: {
            section: 'WALLET',
            actions: ['DOWNLOAD_DOCUMENTS', 'VIEW'],
          },
        },
        component: WalletDocumentCertificate,
      },
    ],
  },
];
